// extracted by mini-css-extract-plugin
export default {"row":"YpWop3","data":"GTh345","row-cell":"GcBaod","rowCell":"GcBaod","table":"jqHHPD","header":"tQCxVD"};